import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=6da3c07a&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=6da3c07a&prod&lang=scss"
import style1 from "./MyOrders.vue?vue&type=style&index=1&id=6da3c07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3c07a",
  null
  
)

export default component.exports